import React from 'react';
import { random } from 'lodash-es';
import { webSocketsService } from 'services/WebSockets';

export const useRefreshIframe = (isReady: boolean): void => {
    const subscribeRef = React.useRef<boolean>(false);

    React.useEffect(() => {
        if (!subscribeRef.current && isReady) {
            webSocketsService.refreshIframe(() => {
                window.setTimeout(() => window.location.reload(), random(1, 15) * 1000);
            });
            subscribeRef.current = true;
        }
    }, [isReady]);
};
